import React from "react";
import {ReactSession} from "react-client-session";
import queryString from "query-string";
import {toast} from "react-toastify";
import {decode as base64_decode, encode as base64_encode} from "base-64";

import { Connection } from "../../config/Connection";
import { Helpers } from "../../config/Helpers";
import GoogleMap from '../../components/GoogleMap';
import AutoComplete from "../../components/AutoComplete";
import OtpInput from 'react-otp-input';

const Marker = props => {
    return <>
        <div className="pin"></div>
        <div className="pulse"></div>
    </>
}

class New extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessUserType: (ReactSession.get("sess_usertype")) ? ReactSession.get("sess_usertype") : '',
            urlParam: queryString.parse(window.location.search),

            mapCenter: {
                lat: -6.213110657838351,
                lng: 106.82010690652227
            },
            mapZoom: 15,
            mapApiLoaded: false,
            mapInstance: null,
            mapApi: null,
            places: [],

            wilayahData: [],

            storeID: '',
            storeWilayah: '',
            storeNama: '',
            storePemilik: '',
            storeEmail: '',
            storeHandphone: '',
            storeOTP: '',
            storePinPoint: '',
            storeDistance: '',
            storeDistanceDisplay: '',
            storeProvinsi: '',
            storeKota: '',
            storeKecamatan: '',
            storeDesa: '',
            storeKodepos: '',
            storeFasilitas: '',
            storeChiller: '',
            storeUkuranChiller: '',
            storeEtalase: '',
            storeSembako: '',
            storeKepemilikan: '',
            storeBangunan: '',
            storeOmset: '',
            storeImage: '',
            storeImageName: '',
            storeImagePreview: '',
            storeImageExisting: '',
            storeCommand: '',
            loading: true,
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getBranch();
        }
    }

    getBranch = () => {
        Helpers.getBranch().then(res => {
            this.setState({
                wilayahData: (res) ? res : []
            }, () => {
                this.getWarungDetail();
            });
        })
    };

    getWarungDetail = () => {
        this.setState({
            storeID: (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '',
            storeCommand: (this.state.urlParam.action) ? this.state.urlParam.action : ''
        }, () => {
            if(this.state.storeID && this.state.storeCommand == 'update'){
                this.getMitraInfo();
            }else{
                this.setState({ loading: false });

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        this.setState({
                            mapCenter: {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            }
                        }, () => {
                            this.googleLocationDetails();
                        });
                    });
                }
            }
        });
    };

    getMitraInfo = () => {
        Helpers.getWarung(this.state.storeID, '').then(res => {
            this.setState({ loading: false });

            if(res && res.length > 0){
                const obj = res[0];

                this.setState({
                    storeWilayah: obj.BranchCode,
                    storeNama: obj.NamaWarung,
                    storePemilik: obj.NamaPemilikWarung,
                    storeEmail: obj.Email,
                    storeHandphone: obj.NoTelepon,
                    storePinPoint: obj.Alamat,
                    storeProvinsi: obj.Provinsi,
                    storeKota: obj.Kota,
                    storeKecamatan: obj.Kecamatan,
                    storeDesa: obj.Kelurahan,
                    storeKodepos: obj.KodePos,
                    storeImageExisting: obj.FotoWarung,
                });
            }
        });
    };

    googleLocationDetails = () => {
        const latlng = this.state.mapCenter.lat + ',' + this.state.mapCenter.lng;

        Helpers.googleLocationDetails(latlng).then(res => {
            this.defaultPlace(res.results[0]);
        });
    };

    handleGenerateMaps = () => {
        const generateMaps = <GoogleMap
            defaultZoom={this.state.mapZoom}
            defaultCenter={this.state.mapCenter}
            bootstrapURLKeys={{
                key: Connection.MAPS_API_KEY,
                libraries: ['places', 'geometry'],
            }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => this.apiHasLoaded(map, maps)}>
            <Marker lat={parseFloat(this.state.mapCenter.lat)} lng={parseFloat(this.state.mapCenter.lng)} />
        </GoogleMap>

        this.setState({
            generateMaps
        });
    };

    apiHasLoaded = (map, maps) => {
        this.setState({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps,
        });
    };

    defaultPlace = (place) => {
        this.setState({
            places: [place],
            mapCenter: {
                lat: place.geometry.location.lat,
                lng: place.geometry.location.lng
            },
            storePinPoint: place.formatted_address,
            storeProvinsi: place.address_components.find(x => x.types[0] === 'administrative_area_level_1').long_name,
            storeKota: place.address_components.find(x => x.types[0] === 'administrative_area_level_2').long_name,
            storeKecamatan: place.address_components.find(x => x.types[0] === 'administrative_area_level_3').long_name,
            storeDesa: place.address_components.find(x => x.types[0] === 'administrative_area_level_4').long_name
        }, () => {
            this.countDistance();
        });
    };

    addPlace = (place) => {
        this.setState({
            places: [place],
            mapCenter: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            },
            storePinPoint: place.formatted_address,
            storeProvinsi: place.address_components.find(x => x.types[0] === 'administrative_area_level_1').long_name,
            storeKota: place.address_components.find(x => x.types[0] === 'administrative_area_level_2').long_name,
            storeKecamatan: place.address_components.find(x => x.types[0] === 'administrative_area_level_3').long_name,
            storeDesa: place.address_components.find(x => x.types[0] === 'administrative_area_level_4').long_name
        }, () => {
            this.countDistance();
        });
    };

    countDistance = () => {
        const destination = this.state.mapCenter.lat + ',' + this.state.mapCenter.lng
        Helpers.countDistance(destination,'').then(res => {
            this.setState({
                storeDistance: res[0].distanceValue,
                storeDistanceDisplay: res[0].distanceText + ' / ' + res[0].durationText,
            }, () => {
                this.handleGenerateMaps();
            });
        })
    };

    handleOTP = () => {
        if(this.state.storeHandphone){
            Helpers.requestOTP(
                'request',
                this.state.storeHandphone,
                ''
            ).then(res => {
                if(res.length > 0){
                    toast[res[0].alert](res[0].message);
                }else{
                    toast.error(Helpers.MSG_ERROR);
                }
            })
        }else{
            toast.error(Helpers.MSG_ERROR_FORM);
        }
    };

    handleImageChange = (e) => {
        const file = e.target.files[0];
        if(!file){
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            this.setState({
                storeImage: reader.result,
                storeImageName: file.name,
                storeImagePreview: reader.result
            });
        };
        reader.readAsDataURL(file);
    };

    handleSubmit = (e) => {
        e.preventDefault();

        var formdata = new FormData();
        formdata.append("img", this.state.storeImage);
        formdata.append("BranchCode", this.state.storeWilayah);
        formdata.append("KodeMarketing", this.state.sessUserCode);
        formdata.append("NamaWarung", this.state.storeNama);
        formdata.append("NamaPemilikWarung", this.state.storePemilik);
        formdata.append("Alamat", this.state.storePinPoint);
        formdata.append("Kelurahan", this.state.storeDesa);
        formdata.append("Kecamatan", this.state.storeKecamatan);
        formdata.append("KodePos", this.state.storeKodepos);
        formdata.append("NoTelepon", this.state.storeHandphone);
        formdata.append("FotoWarung", this.state.storeImageName);
        formdata.append("Keterangan", this.state.storeFasilitas);
        formdata.append("Chiler", this.state.storeChiller);
        formdata.append("UkuranCaseChiller", this.state.storeUkuranChiller);
        formdata.append("UkuranEtalase", this.state.storeEtalase);
        formdata.append("Sembako", this.state.storeSembako);
        formdata.append("Kepemilikan", this.state.storeKepemilikan);
        formdata.append("JenisBangunan", this.state.storeBangunan);
        formdata.append("OmsetPerHari", this.state.storeOmset);
        formdata.append("Email", this.state.storeEmail);
        formdata.append("Password", '');
        formdata.append("Coordinate", this.state.mapCenter.lat + ',' + this.state.mapCenter.lng);
        formdata.append("Akurasi", this.state.storeDistance);
        formdata.append("OTP", this.state.storeOTP);
        formdata.append("Provinsi", this.state.storeProvinsi);
        formdata.append("Kota", this.state.storeKota);

        if(this.state.storeID){
            formdata.append("id", this.state.storeID);
        }

        fetch(Connection.SOAP_SaveMitraUpload, {
            method: 'POST',
            body: formdata
        }).then((res) => res.json()).then((res) => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    setTimeout(function() {
                        window.location.href = './store';
                    }, 1000);
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        }).catch((error) => {
            toast.error(error.toString());
        });
    };

    render() {
        const isEdit = !!this.state.storeID;

        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./store" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">{isEdit ? 'Ubah Mitra' : 'Tambah Mitra'}</h1>
                    </div>

                    <div className="detail-wrap">
                        <div className="partner-photo-card">
                            <label htmlFor="storeImageInput" className="partner-photo-label">
                                {
                                    this.state.storeImagePreview ? (
                                        <img src={this.state.storeImagePreview} alt="" className="partner-photo-preview"/>
                                    ) : this.state.storeImageExisting ? (
                                        <img src={'https://waroq.com/WRQSVC/image/FotoWarung/' + this.state.storeImageExisting} alt="" className="partner-photo-preview"/>
                                    ) : (
                                        <div className="partner-photo-placeholder">
                                            <i className="fi-rs-shop"></i>
                                        </div>
                                    )
                                }
                                <span className="partner-photo-text">Unggah Foto Mitra</span>
                            </label>
                            <input id="storeImageInput" type="file" accept="image/*" style={{display: 'none'}} onChange={this.handleImageChange}/>
                        </div>

                        {
                            this.state.mapApiLoaded && (
                                <AutoComplete map={this.state.mapInstance} mapApi={this.state.mapApi} addplace={this.addPlace} />
                            )
                        }
                        <div className="location-map-card">
                            <div style={{ height: '260px', width: '100%' }}>
                                {this.state.generateMaps}
                            </div>
                        </div>

                        <form method="post" onSubmit={(e) => {this.handleSubmit(e)}}>
                            <div className="detail-card">
                                <div className="detail-card-head">
                                    <span className="detail-card-accent"></span>
                                    <span className="detail-card-title">Info Mitra</span>
                                </div>

                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <select className="location-select" required value={this.state.storeWilayah} onChange={e => this.setState({storeWilayah: e.target.value})}>
                                        <option value={''}>Pilih Wilayah</option>
                                        {
                                            this.state.wilayahData.map((object, i) => (
                                                <option key={i} value={object.BranchCode}>{object.BranchName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-shop auth-input-icon"></i>
                                    <input value={this.state.storeNama} onChange={e => this.setState({storeNama: e.target.value})}
                                           placeholder="Nama Mitra"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-user auth-input-icon"></i>
                                    <input value={this.state.storePemilik} onChange={e => this.setState({storePemilik: e.target.value})}
                                           placeholder="Nama Pemilik (Sesuai KTP)"
                                           type="text" required/>
                                </div>

                                {
                                    !isEdit && (
                                        <>
                                            <div className="auth-input-group mb-15">
                                                <i className="fi-rs-envelope auth-input-icon"></i>
                                                <input value={this.state.storeEmail} onChange={e => this.setState({storeEmail: e.target.value})}
                                                       placeholder="Email Pemilik"
                                                       type="email" required/>
                                            </div>

                                            <div className="auth-otp-request mb-15">
                                                <div className="auth-input-group" style={{flex: 1}}>
                                                    <i className="fi-rs-smartphone auth-input-icon"></i>
                                                    <input required type="number" value={this.state.storeHandphone} onChange={e => this.setState({storeHandphone: e.target.value})}
                                                           min={0}
                                                           placeholder="Nomor HP"/>
                                                </div>
                                                <button type="button" className="auth-btn-otp" onClick={() => {this.handleOTP()}}>Kirim OTP</button>
                                            </div>

                                            <div className="auth-otp-input">
                                                <OtpInput
                                                    inputStyle="auth-otp-box"
                                                    containerStyle="auth-otp-container"
                                                    value={this.state.storeOTP}
                                                    onChange={storeOTP => this.setState({storeOTP})}
                                                    numInputs={6}
                                                    isInputSecure={true}
                                                    separator={<span>&nbsp;</span>}
                                                />
                                            </div>
                                        </>
                                    )
                                }
                            </div>

                            <div className="detail-card">
                                <div className="detail-card-head">
                                    <span className="detail-card-accent"></span>
                                    <span className="detail-card-title">Info Alamat</span>
                                </div>

                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-marker auth-input-icon"></i>
                                    <textarea className="location-textarea" value={this.state.storePinPoint} onChange={e => this.setState({storePinPoint: e.target.value})}
                                              placeholder="Cari atau arahkan pin sesuai lokasi anda"
                                              required />
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-time-past auth-input-icon"></i>
                                    <input value={this.state.storeDistanceDisplay} onChange={e => this.setState({storeDistanceDisplay: e.target.value})}
                                           placeholder="Estimasi Jarak & Waktu Tempuh Dari Gudang"
                                           type="text" readOnly/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.storeProvinsi} onChange={e => this.setState({storeProvinsi: e.target.value})}
                                           placeholder="Provinsi"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.storeKota} onChange={e => this.setState({storeKota: e.target.value})}
                                           placeholder="Kota"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.storeKecamatan} onChange={e => this.setState({storeKecamatan: e.target.value})}
                                           placeholder="Kecamatan"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.storeDesa} onChange={e => this.setState({storeDesa: e.target.value})}
                                           placeholder="Kelurahan"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group">
                                    <i className="fi-rs-envelope auth-input-icon"></i>
                                    <input value={this.state.storeKodepos} onChange={e => this.setState({storeKodepos: e.target.value})}
                                           placeholder="Kode Pos"
                                           type="number" maxLength={5} required/>
                                </div>
                            </div>

                            <div className="detail-card">
                                <div className="detail-card-head">
                                    <span className="detail-card-accent"></span>
                                    <span className="detail-card-title">Info Tambahan</span>
                                </div>

                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-school auth-input-icon"></i>
                                    <input value={this.state.storeFasilitas} onChange={e => this.setState({storeFasilitas: e.target.value})}
                                           placeholder="Fasilitas Umum Terdekat, e.g. SD Sukasenang 2"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <select className="location-select" required value={this.state.storeChiller} onChange={e => this.setState({storeChiller: e.target.value})}>
                                        <option value={''}>Punya Chiller?</option>
                                        <option value={'Yes'}>Ya</option>
                                        <option value={'No'}>Tidak</option>
                                    </select>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <input value={this.state.storeUkuranChiller} onChange={e => this.setState({storeUkuranChiller: e.target.value})}
                                           placeholder="Ukuran Chiller"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <input value={this.state.storeEtalase} onChange={e => this.setState({storeEtalase: e.target.value})}
                                           placeholder="Ukuran Etalase"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <select className="location-select" required value={this.state.storeSembako} onChange={e => this.setState({storeSembako: e.target.value})}>
                                        <option value={''}>Jual Sembako?</option>
                                        <option value={'Yes'}>Ya</option>
                                        <option value={'No'}>Tidak</option>
                                    </select>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <select className="location-select" required value={this.state.storeKepemilikan} onChange={e => this.setState({storeKepemilikan: e.target.value})}>
                                        <option value={''}>Kepemilikan Bangunan</option>
                                        <option value={'Milih Sendiri'}>Milik Sendiri</option>
                                        <option value={'Kontrak'}>Kontrak</option>
                                    </select>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <select className="location-select" required value={this.state.storeBangunan} onChange={e => this.setState({storeBangunan: e.target.value})}>
                                        <option value={''}>Jenis Bangunan</option>
                                        <option value={'Permanen'}>Permanen</option>
                                        <option value={'Semi Permanen'}>Semi Permanen</option>
                                    </select>
                                </div>
                                <div className="auth-input-group">
                                    <input value={this.state.storeOmset} onChange={e => this.setState({storeOmset: e.target.value})}
                                           placeholder="Omset Per Hari (Rupiah)"
                                           min={0}
                                           type="number" required/>
                                </div>
                            </div>

                            <button type="submit" className="auth-btn-primary mb-15">Simpan</button>
                        </form>
                    </div>
                </main>
            </>
        );
    }
}

export default New;
